import { useCallback } from 'react';
import { PrimitiveAtom, useAtom, useSetAtom } from 'jotai';
import { ButtonGroup, Tooltip } from '@mui/material';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { OutlinedIconButton } from './styles';
import { CuboidBase, CuboidDataHandlers, CuboidState } from '../../types';

type HideCuboidButtonGroupProps<CuboidT extends CuboidBase> = {
  cuboidState: CuboidState<CuboidT>;
  hiddenCuboidIds: PrimitiveAtom<Set<string>>;
};

export const HideCuboidButtonGroup = <CuboidT extends CuboidBase>({
  cuboidState,
  hiddenCuboidIds,
}: HideCuboidButtonGroupProps<CuboidT>) => {
  const [currentCuboid, setCurrentCuboid] = useAtom(cuboidState.currentCuboid);

  const setHiddenCuboidIds = useSetAtom(hiddenCuboidIds);

  const handleHideCurrentCuboid = useCallback(() => {
    if (!currentCuboid) return;
    const cuboidId = currentCuboid.cuboidData.id;
    setHiddenCuboidIds((current) => {
      const next = new Set(current);
      next.add(cuboidId);
      return next;
    });
    setCurrentCuboid(undefined);
  }, [currentCuboid, setCurrentCuboid, setHiddenCuboidIds]);

  return (
    <ButtonGroup sx={{ paddingBottom: '10px' }}>
      <Tooltip title="Hide cuboid">
        <OutlinedIconButton onClick={handleHideCurrentCuboid} disabled={!currentCuboid}>
          <VisibilityOffIcon style={{ color: '#fff' }} />
        </OutlinedIconButton>
      </Tooltip>
    </ButtonGroup>
  );
};
